
import { Options, Prop, Vue } from 'vue-property-decorator'

@Options({
  name: 'DarkMode'
})
export default class DarkMode extends Vue {
  @Prop({
    type: String,
    default: 'auto'
  })
  theme!: 'dark' | 'light' | 'auto'
}
